import { Checkbox, Fab, ListItemText, makeStyles, MenuItem, TextField } from '@material-ui/core';
import React, { useMemo } from 'react';
import { useForm, Controller } from 'react-hook-form';
import FilterIcon from '@material-ui/icons/FilterList';
import { useRecentGetter } from '@lib/common';
import { $in } from '../operators';
import { startCase } from 'lodash';

type EnumObject = { label: React.ReactNode; value: any };
type EnumMap = EnumObject[];
const useStyles = makeStyles({
  root: {
    width: '300px',
  },
  center: {
    textAlign: 'center',
  },
});

export function withEnumMultiSelect(
  enumMap: EnumMap,
  captitalizeOptions: boolean = false,
  retainSpecialChars: boolean = false
) {
  return function EnumFiltersMultiSelect(props) {
    const classes = useStyles();
    const { handleSubmit, ...form } = useForm();
    const {
      column: { filterValue, setFilter },
      closeFilter,
    } = props;

    const getFilterValue = useRecentGetter(filterValue);
    const getFilterSetter = useRecentGetter(setFilter);
    const getCloseFilter = useRecentGetter(closeFilter);

    const submit = useMemo(
      () =>
        handleSubmit(values => {
          const toSet = {
            ...getFilterValue(),
          };
          if (values.value.length) {
            toSet[$in.key] = values.value.join(',');
            getFilterSetter()(toSet);
          }
          getCloseFilter()();
        }),
      []
    );

    return (
      <form onSubmit={submit}>
        <Controller
          control={form.control}
          name="value"
          defaultValue={[]}
          render={({ onChange, value }) => {
            return (
              <TextField
                classes={{ root: classes.root }}
                select
                id="Values"
                variant="outlined"
                label="Select one/multiple"
                SelectProps={{
                  multiple: true,
                  value: value,
                  renderValue: selected =>
                    (selected as Array<string>)
                      .map(element =>
                        captitalizeOptions
                          ? (element as string).toUpperCase()
                          : retainSpecialChars
                          ? element
                          : startCase(element)
                      )
                      .join(', '),
                  onChange: onChange,
                  MenuProps: {
                    anchorOrigin: {
                      vertical: 'bottom',
                      horizontal: 'left',
                    },
                    transformOrigin: {
                      vertical: 'top',
                      horizontal: 'left',
                    },
                    getContentAnchorEl: null,
                    style: { maxHeight: '50vh' },
                  },
                }}>
                {enumMap.map(v => {
                  return (
                    <MenuItem key={v.value} value={v.value}>
                      <Checkbox checked={value.includes(v.value)} />
                      <ListItemText
                        primary={
                          captitalizeOptions
                            ? (v.label as string).toUpperCase()
                            : retainSpecialChars
                            ? v.label
                            : startCase(v.label as string)
                        }
                      />
                    </MenuItem>
                  );
                })}
              </TextField>
            );
          }}
        />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <Fab color="primary" size="small" type="submit">
          <FilterIcon />
        </Fab>
      </form>
    );
  };
}
